/**
 * ThemePicker — wybór motywu (tła) generowanej strony.
 * Opcje przekazywane z zewnątrz: [{ id, label, swatch }].
 */
import { Check } from 'lucide-react';

export default function ThemePicker({
  value, onChange, options = [],
  title = 'Motyw kolorystyczny', desc = 'Tło i charakter Twojej strony.',
}) {
  const active = value || options[0]?.id;
  return (
    <div data-testid="theme-picker" className="rounded-2xl border border-gray-200 bg-white p-5">
      <div className="mb-3">
        <p className="text-sm font-semibold text-gray-900">{title}</p>
        <p className="text-xs text-gray-500 mt-0.5">{desc}</p>
      </div>
      <div className="flex flex-wrap gap-2.5">
        {options.map((o) => {
          const isActive = active === o.id;
          return (
            <button
              key={o.id}
              type="button"
              data-testid={`theme-${o.id}`}
              onClick={() => onChange?.(o.id)}
              className={`relative flex items-center gap-2 rounded-xl border-2 pl-2 pr-3 py-2 transition-all ${isActive ? 'border-amber-500 bg-amber-50/50 ring-2 ring-amber-500/20' : 'border-gray-200 hover:border-gray-300'}`}
            >
              <span className="w-6 h-6 rounded-lg border border-black/10 shadow-inner" style={{ background: o.swatch }} />
              <span className="text-[13px] font-medium text-gray-900">{o.label}</span>
              {isActive && <Check className="w-3.5 h-3.5 text-amber-600" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
